import * as Yup from 'yup';

const isAtLeast18 = (date: Date | null) => {
  if (!date || isNaN(date.getTime())) return false;

  const today = new Date();
  const eighteenYearsAgo = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  );

  return date <= eighteenYearsAgo;
};

export const campaignLeadSchema = () =>
  Yup.object({
    firstName: Yup.string()
      .trim()
      .required('First name is required.')
      .min(2, 'First name must be at least 2 characters'),
    lastName: Yup.string()
      .trim()
      .required('Last name is required.')
      .min(2, 'First name must be at least 2 characters'),
    address: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    zipCode: Yup.string()
      //.matches(/^\d{5}(-\d{4})?$/, 'Invalid ZIP code')
      .required('Zipcode is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    mobileNumber: Yup.string()
      .matches(/^\+?[0-9\s]+$/, 'Mobile number must contain only digits')
      .min(10, 'Phone number must be at least 10 digits')
      .required('Mobile number is required'),
    driverLicense: Yup.string()
      .min(4, 'Last 4 of drivers license is required')
      .required('Last 4 of drivers license is required'),
    dateOfBirth: Yup.string()
      .required('Date of birth is required')
      .test('is-18', 'You must be at least 18 years old', (value) => {
        if (!value) return false;
        return isAtLeast18(new Date(value));
      }),
  });

export const campaignLeadQuestionsSchema = () =>
  Yup.object({
    heardAboutAutoShow: Yup.string().required(
      'Please select how you heard about the show.',
    ),
    purchaseVehicleNext6Months: Yup.string().required(
      'Please select yes or no.',
    ),
  });
